import React from 'react';

import Modal from './Modal';
import { useSessionContext } from './SessionContext';

export default function DisclaimerModal() {
  const { showDisclaimerModal, setShowDisclaimerModal } = useSessionContext();

  return (
    <Modal showModal={showDisclaimerModal} setShowModal={setShowDisclaimerModal}>
      <h3 style={{ margin: '4px' }}>Disclaimer</h3>
      <p>
        This website is for educational purposes only and aims to highlight water risks around the
        world. The information provided here is not intended to serve as professional advice. While
        we strive to ensure the accuracy and reliability of the information, we make no guarantees
        about its completeness, accuracy, or suitability for any particular purpose. Users should
        independently verify and consult relevant experts or authorities before making decisions
        based on the content provided on this site.
      </p>
    </Modal>
  );
}
